export const GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID = "GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID"
export const GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID_SUCCESS = "GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID_SUCCESS"
export const GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID_FAIL = "GET_PAYMENT_PAGE_TRANSACTION_BY_UNIQUE_ID_FAIL"

export const HOSTED_PAGE_DO_PAYMENT = "HOSTED_PAGE_DO_PAYMENT"
export const HOSTED_PAGE_DO_PAYMENT_SUCCESS = "HOSTED_PAGE_DO_PAYMENT_SUCCESS"
export const HOSTED_PAGE_DO_PAYMENT_FAIL = "HOSTED_PAGE_DO_PAYMENT_FAIL"

export const CHECK_BIN_CARD_NUMBER = "CHECK_BIN_CARD_NUMBER"
export const CHECK_BIN_CARD_NUMBER_SUCCESS = "CHECK_BIN_CARD_NUMBER_SUCCESS"
export const CHECK_BIN_CARD_NUMBER_FAIL = "CHECK_BIN_CARD_NUMBER_FAIL"
export const HOSTED_PAYMENT_CLEAR_CHECK_BIN_ERROR = "HOSTED_PAYMENT_CLEAR_CHECK_BIN_ERROR"

export const HOSTED_PAYMENT_PAGE_API_ERROR = "HOSTED_PAYMENT_PAGE_API_ERROR"

